<template>
  <b-modal
    id="modal-repru-leistung-freigabe-zuruecknehmen"
    v-model="showModal"
    :visible="showModal"
    centered
    size="md"
    @hidden="onModalHidden"
    modal-class="repru-freigabe-zuruecknehmen-modal"
    footer-class="modal-footer--centered"
  >
    <template #modal-title>
      <span class="modal-title-text">Freigabe der markierten Leistungen zurücknehmen</span>
    </template>
    <div class="d-flex flex-column px-2">
      <div class="form-group mb-4">
        Rechnungsnummer:
        <strong>{{ rechnungsnummer }}</strong>
      </div>

      <div class="">
        <span>
          Freigegebener Betrag:
          <strong>{{ formatBetrag(gesamtBetrag) }} {{ waehrung }}</strong>
        </span>
      </div>
    </div>

    <template #modal-footer>
      <b-button class="dialog-btn-secondary" @click="abbrechen">Abbrechen</b-button>
      <b-button class="dialog-btn" variant="primary" @click="onFreigabeZuruecknehmen">
        Freigabe zurücknehmen
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { formatRechnungsnummern } from '@/core/common/helpers/utils.js';

export default {
  name: 'RepruLeistungFreigabeZuruecknehmenModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    selectedLeistungen: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {
    showModal: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
    rechnungsnummer() {
      if (this.selectedLeistungen.length === 0) return '-';
      const erste = this.selectedLeistungen[0];
      return formatRechnungsnummern(erste.freigaben, erste.waehrung);
    },
    gesamtBetrag() {
      return this.selectedLeistungen.reduce((sum, leistung) => sum + (leistung.freigabebetrag || 0), 0);
    },
    waehrung() {
      return this.selectedLeistungen.length > 0 ? this.selectedLeistungen[0].waehrung || '€' : '€';
    },
  },
  watch: {
    visible(newVal) {
      if (!newVal) {
        this.resetModal();
      }
    },
  },
  methods: {
    abbrechen() {
      this.showModal = false;
    },
    onModalHidden() {
      this.resetModal();
    },
    resetModal() {
      // Reset logic if needed
    },
    onFreigabeZuruecknehmen() {
      this.$emit('freigabeZuruecknehmen', {
        leistungen: this.selectedLeistungen,
        rechnungsnummer: this.rechnungsnummer,
      });

      this.showModal = false;
    },
    formatBetrag(betrag) {
      if (betrag == null) return '0,00';
      return betrag.toLocaleString('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
  },
};
</script>

<style scoped>
.modal-title-text {
  font-size: 17px;
  font-weight: 600;
}
::v-deep .repru-freigabe-zuruecknehmen-modal .modal-dialog {
  max-width: 550px;
}
</style>
